// Todas las claves/URLs salen de variables de entorno (REACT_APP_*), que CRA inyecta en tiempo de BUILD.
// Ver .env.example. Ojo: lo que va en el bundle del navegador es visible para cualquiera.
const required = (name: string, value: string | undefined): string => {
    if (!value) console.error(`Falta la variable de entorno ${name}`);
    return value ?? "";
};

export const API_URL = required("REACT_APP_API_URL", process.env.REACT_APP_API_URL);
export const GOOGLE_CLIENT_ID = required("REACT_APP_GOOGLE_CLIENT_ID", process.env.REACT_APP_GOOGLE_CLIENT_ID);
export const GOOGLE_MAPS_API_KEY = required("REACT_APP_GOOGLE_MAPS_API_KEY", process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
export const MIXPANEL_TOKEN = required("REACT_APP_MIXPANEL_TOKEN", process.env.REACT_APP_MIXPANEL_TOKEN);
export const META_PIXEL_ID = required("REACT_APP_META_PIXEL_ID", process.env.REACT_APP_META_PIXEL_ID);
export const WOMPI_PUBLIC_KEY = required("REACT_APP_WOMPI_PUBLIC_KEY", process.env.REACT_APP_WOMPI_PUBLIC_KEY);
export const WOMPI_INTEGRITY_SECRET = required("REACT_APP_WOMPI_INTEGRITY_SECRET", process.env.REACT_APP_WOMPI_INTEGRITY_SECRET);
export const ULTRAMSG_INSTANCE = required("REACT_APP_ULTRAMSG_INSTANCE", process.env.REACT_APP_ULTRAMSG_INSTANCE);
export const ULTRAMSG_TOKEN = required("REACT_APP_ULTRAMSG_TOKEN", process.env.REACT_APP_ULTRAMSG_TOKEN);
